import {post,get} from '@/ulits/http'

// 充值内容
export function contentList(){
  return get('api/topup/get-topup-content-list')
}

// 生成订单号

export function orderOn(parmas){
  return post('api/topup/generate-pay-order',parmas)
} 

// 微信支付参数

export function wxpay(parmas) {
  return post('api/topup/pay',parmas)
}

// 花瓣流水

export function balanceLog(parmas) {
  return get('api/user/petal-balance-log', parmas)
} 

// 会员兑换
export function exchangeCode(parmas) {
  return post('api/topup/exchange-coupon-code',parmas)
}

// 订单查询
export function getPayInfo(parmas) {
  return get('api/topup/get-pay-info',parmas)
}